import { sGisEvent } from "@evergis/sgis/es/EventHandler";
import { SnappingData } from "./ServerSnappingProvider";

export class SnappingDataReceiveEvent extends sGisEvent {
  static type = "snappingDataReceive";

  readonly snappingData: SnappingData;

  constructor(snappingData: SnappingData) {
    super(SnappingDataReceiveEvent.type);

    this.snappingData = snappingData;
  }
}
